<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
defineEmits<{
  'on-tile-click': [void],
}>();

function disableScroll() {
  const htmlSelector = document.querySelector('html');
  htmlSelector.style.overflow = 'hidden';
}

const selectedDestination = defineModel('destination', {default: ''});


</script>

<template>
  <div
      id="destination"
      @click="disableScroll();$emit('on-tile-click');"
      class="flex flex-col justify-between h-full bg-gradient-to-br from-gradients-ghostWhite to-gradients-aliceBlue px-5 py-4 w-full transition-all rounded-11xl"
  >
    <div class="text-black/65 flex flex-row items-center gap-2 responsive-body-small">
      <img src="@/assets/icons/svg/Location_16x16.svg" alt="Destination">
      <span>{{ t('search.destinationTitle') }}</span>
    </div>
    <div
        class="text-black responsive-title-5 cursor-default w-full outline-none pt-3 placeholder-black placeholder-shown:"
    >
      {{ selectedDestination === '' ? t('booking.selectDestination') : selectedDestination }}
    </div>
  </div>
</template>
